import { defineComponent, computed } from "vue";
import { processMediaItem } from "@i22/rocket";
import { getMainImageFromOffer } from "./component-library84.mjs";
import ImageElement from "./component-library8.mjs";
import PictureElement from "./component-library9.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "goliath-image-element",
  props: {
    imageClass: { default: void 0 },
    imageStyle: { default: void 0 },
    format: { default: void 0 },
    doNotConvert: { type: Boolean },
    preload: { type: Boolean },
    image: { default: void 0 },
    offer: { default: void 0 },
    alt: { default: void 0 },
    productName: { default: void 0 },
    xsWidth: { default: "medium" },
    smWidth: { default: "large" },
    lazy: { type: Boolean },
    renderWithoutFigure: { type: Boolean },
    sizes: { default: void 0 }
  },
  emits: ["image-error"],
  setup(__props, { expose }) {
    const props = __props;
    const getFiltersProps = (props2, blacklist) => {
      const filteredProps = {};
      Object.keys(props2).forEach((propName) => {
        if (blacklist.includes(propName))
          return;
        filteredProps[propName] = props2[propName];
      });
      return filteredProps;
    };
    const getUrl = (path) => {
      if (!path)
        return void 0;
      return path.replace(/\/public\//, "/product-images/");
    };
    const getImagesByWidth = (image, targetSize = "medium") => {
      let localImage = image;
      if (image.mediaId && !image.medium) {
        localImage = processMediaItem(image);
      }
      switch (targetSize) {
        case "small":
          return getUrl(localImage.small);
        case "medium":
          return getUrl(localImage.medium);
        default:
          return getUrl(localImage.large);
      }
    };
    const passThroughProps = computed(() => {
      return getFiltersProps(props, [
        "offer",
        "src",
        "renderWithoutFigure",
        "image",
        "xsWidth",
        "smWidth"
      ]);
    });
    const parsedImage = computed(() => {
      if (props.image)
        return props.image;
      if (props.offer)
        return getMainImageFromOffer(props.offer);
      return void 0;
    });
    const computedAlt = computed(() => {
      var _a;
      if (props.alt)
        return props.alt;
      if (!((_a = parsedImage.value) == null ? void 0 : _a.name))
        return void 0;
      return parsedImage.value.name !== props.productName ? parsedImage.value.name : void 0;
    });
    const src = computed(() => {
      if (!parsedImage.value)
        return void 0;
      if (props.sizes) {
        return getImagesByWidth(parsedImage.value, "large");
      }
      return getImagesByWidth(parsedImage.value, props.xsWidth);
    });
    const srcSm = computed(() => {
      if (!parsedImage.value || props.sizes)
        return void 0;
      return getImagesByWidth(parsedImage.value, props.smWidth);
    });
    expose({
      src,
      srcSm
    });
    return { __sfc: true, getFiltersProps, getUrl, getImagesByWidth, props, passThroughProps, parsedImage, computedAlt, src, srcSm, ImageElement, PictureElement };
  }
});
export {
  _sfc_main as default
};
